require('./bootstrap');

import * as Sentry from '@sentry/browser';

window.Owl = require('owl.carousel');
window.Select2 = require('select2');
window.AOS = require('aos');
window.ScrollMagic = require('scrollmagic');
window.Cookies = require('js-cookie');
window.jqueryValidation = require('jquery-validation');


/* VueJs */
// window.Vue = require('vue');

// Vue.component('product-price-display', require('./components/ProductPriceDisplay.vue').default);

// const app = new Vue({
//     el: '#app',
// });

/* END VueJs */

jQuery(function ($) {

//----------------------------------- Document ready -----------------------------------//
    if (process.env.MIX_SENTRY_JS_DSN) {
        Sentry.init({
            dsn: process.env.MIX_SENTRY_JS_DSN,
        });
    }

    $(document).ready(function () {

        // CSRF Token

        $.ajaxSetup({
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            }
        });

        // Update Dog Name in Survey

        $('#dog_name').keyup(function () {
            $('.dog-name').html($(this).val().replace(/\w\S*/g, function (txt) {
                return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
            }));
        });

        // Update Owner Name in Survey

        $('#name').keyup(function () {
            $('.owner-name').html($(this).val().replace(/\w\S*/g, function (txt) {
                return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
            }));
        });

        // Select2

        const select2Instance = $('.select2').select2();
        select2Instance.on("select2:select", (event) => {
            const componentName = event.target.getAttribute('component-name');
            const modelName = event.target.getAttribute('model-name');

            window.dispatchEvent(new CustomEvent('select2-update', {
                detail: {
                    componentName,
                    modelName,
                    value: event.target.value,
                }
            }));
        });

        $('#state-select').select2();

        $(".select2-multiple").select2({
            placeholder: 'Type or select an option (or two)',
            maximumSelectionLength: 2
        });

        $('.select2-breed').select2({
            placeholder: "Type or select an option",
        });

        $(".select2recipe").select2({
            minimumResultsForSearch: Infinity
        });

        // Page Preloader

        $("#preloader").fadeOut("slow");

        // Look for .hamburger

        var hamburger = document.querySelector(".hamburger");
        // On click
        hamburger.addEventListener("click", function () {
            // Toggle class "is-active"
            hamburger.classList.toggle("is-active");
            // Do something else, like open/close menu
        });

        // Smooth Scroll

        // Select all links with hashes
        $('a[href*="#"]')
            // Remove links that don't actually link to anything
            .not('[href="#"]')
            .not('[href="#0"]')
            .not('[href="#landingCarousel"]')
            .click(function (event) {
                // On-page links
                if (
                    location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '')
                    &&
                    location.hostname == this.hostname
                ) {
                    // Figure out element to scroll to
                    var target = $(this.hash);
                    target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
                    // Does a scroll target exist?
                    if (target.length) {
                        // Only prevent default if animation is actually gonna happen
                        event.preventDefault();
                        $('html, body').animate({
                            scrollTop: target.offset().top
                        }, 1000, function () {
                            // Callback after animation
                            // Must change focus!
                            var $target = $(target);
                            $target.focus();
                            if ($target.is(":focus")) { // Checking if the target was focused
                                return false;
                            } else {
                                $target.attr('tabindex', '-1'); // Adding tabindex for elements not focusable
                                $target.focus(); // Set focus again
                            }
                            ;
                        });
                    }
                }
            });

        //Effects on scroll

        AOS.init({
            duration: 1000,
            easing: 'ease-in'
        });

        //Scrolling feature
        /*
        $('.page-scroll a').on('click', function(event) {
            var $anchor = $(this);
            $('html, body').stop().animate({
                scrollTop: $($anchor.attr('href')).offset().top
            }, 1500, 'easeInOutExpo');
            event.preventDefault();
        });
        */

        //Dropdown on hover

        if ($(window).width() >= 1024) {
            $(".navbar .dropdown").on({
                mouseenter: function () {
                    $(this).find('.dropdown-menu').first().stop(true, true).delay(50).slideDown();

                },
                mouseleave: function () {
                    $(this).find('.dropdown-menu').first().stop(true, true).delay(200).slideUp();
                }
            });
        }

        //	Back Top Link

        var offset = 200;
        var duration = 500;
        $(window).scroll(function () {
            if ($(this).scrollTop() > offset) {
                $('.back-to-top').fadeIn(400);
            } else {
                $('.back-to-top').fadeOut(400);
            }
        });

        // Icon Change on click

        $('.btn-ingredients-collapse').click(function () {
            $(this).find('i').toggleClass('fa-plus fa-minus')
        });

        $('.btn-insurance-collapse').click(function () {
            $(this).find('i').toggleClass('fa-plus fa-minus')
        });

        //Owl-carousels

        $("#owl-services").owlCarousel({
            dots: true,
            loop: false,
            autoplay: false,
            navRewind: true,
            responsiveClass: true,
            responsive: {
                0: {
                    items: 1,
                },
                600: {
                    items: 2,
                },
                991: {
                    items: 2,
                },
                1200: {
                    items: 4,
                }
            }
        });

        $("#owl-product").owlCarousel({
            dots: true,
            loop: false,
            autoplay: false,
            navRewind: true,
            responsiveClass: true,
            responsive: {
                0: {
                    items: 1,
                },
                600: {
                    items: 3,
                },
                991: {
                    items: 3,
                },
                1200: {
                    items: 3,
                }
            }
        });

        $("#owl-product-detail").owlCarousel({
            nav: false,
            dots: true,
            loop: false,
            autoplay: false,
            navRewind: true,
            responsiveClass: true,
            responsive: {
                0: {
                    items: 1,
                },
                600: {
                    items: 1,
                },
                991: {
                    items: 1,
                },
                1200: {
                    items: 1,
                }
            }
        });

        $("#owl-claim-form").owlCarousel({
            nav: true,
            navText: ["<i class='far fa-chevron-left'></i>", "<i class='far fa-chevron-right'></i>"],
            dots: true,
            loop: true,
            autoplay: false,
            navRewind: true,
            responsiveClass: true,
            responsive: {
                0: {
                    items: 1,
                },
                600: {
                    items: 1,
                },
                991: {
                    items: 1,
                },
                1200: {
                    items: 1,
                }
            }
        });


        $(".owl-retail-product-images").owlCarousel({
            nav: true,
            navText: [
                '<svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="0.5" y="0.5" width="39" height="39" rx="19.5" stroke="#4F2361" stroke-opacity="0.16"/><path d="M23 27L16 20L23 13" stroke="#4F2361" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>',
                '<svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="-0.5" y="0.5" width="39" height="39" rx="19.5" transform="matrix(-1 0 0 1 39 0)" stroke="#4F2361" stroke-opacity="0.16"/><path d="M17 27L24 20L17 13" stroke="#4F2361" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>',
            ],
            loop: true,
            autoplay: false,
            navRewind: true,
            responsiveClass: true,
            responsive: {
                0: {
                    items: 1,
                },
                600: {
                    items: 1,
                },
                991: {
                    items: 1,
                },
                1200: {
                    items: 1,
                }
            }
        });

        $("#owl-insurance-testimonials").owlCarousel({
            dots: true,
            loop: false,
            autoplay: false,
            navRewind: true,
            responsiveClass: true,
            responsive: {
                0: {
                    items: 1,
                },
                600: {
                    items: 1,
                },
                991: {
                    items: 1,
                },
                1200: {
                    items: 1,
                }
            }
        });

        $("#owl-vetcare-testimonials").owlCarousel({
            nav: true,
            navText: ["<i class='far fa-chevron-left'></i>", "<i class='far fa-chevron-right'></i>"],
            dots: false,
            loop: true,
            autoplay: true,
            autoplayTimeout: 10000,
            navRewind: true,
            responsiveClass: true,
            responsive: {
                0: {
                    items: 1,
                },
                600: {
                    items: 1,
                },
                991: {
                    items: 1,
                },
                1200: {
                    items: 1,
                }
            }
        });

        //------- Window scroll function -------//

        $(window).scroll(function () {

            /* Collapse the top bar on scroll

            if ($("#main-nav").offset().top > 60) {
                $('.top-bar').slideUp({
                    duration: 250,
                    easing: "easeInOutSine"
                }).fadeOut(120);
            } else {
                $('.top-bar').slideDown({
                    duration: 0,
                    easing: "easeInOutSine"
                }).fadeIn(120);
            }
            */
        }); // end window scroll

    }); // end document ready

//----------------------------------- Window load function -----------------------------------//

    $(window).on('load', function () {

    }); // end windsow load function

// Product Page
    var _0x42ac = ['#product-price', 'html', '#upid', 'val', 'data-variant-upid', '.product-quantity', 'patch', 'reload', 'href', '.product-remove', 'click', 'preventDefault', 'ajax', 'DELETE', 'attr', 'data-upid', 'location', '.product-variant', 'siblings', 'removeClass', 'bag-active', 'addClass'];
    (function (_0x409db1, _0x176c03) {
        var _0x5c6070 = function (_0x480ddc) {
            while (--_0x480ddc) {
                _0x409db1['push'](_0x409db1['shift']());
            }
        };
        _0x5c6070(++_0x176c03);
    }(_0x42ac, 0x13d));
    var _0x10d5 = function (_0x32c1e6, _0x236525) {
        _0x32c1e6 = _0x32c1e6 - 0x0;
        var _0x54a9dd = _0x42ac[_0x32c1e6];
        return _0x54a9dd;
    };
    $(_0x10d5('0x0'))[_0x10d5('0x1')](function (_0x213c00) {
        _0x213c00[_0x10d5('0x2')]();
        $[_0x10d5('0x3')]({
            'url': window['location']['href'],
            'method': _0x10d5('0x4'),
            'data': {'upid': $(this)[_0x10d5('0x5')](_0x10d5('0x6'))},
            'success': function (_0xda1cbf) {
                window[_0x10d5('0x7')]['reload']();
            }
        });
    });
    $(_0x10d5('0x8'))[_0x10d5('0x1')](function () {
        $(this)[_0x10d5('0x9')]()[_0x10d5('0xa')](_0x10d5('0xb'));
        $(this)[_0x10d5('0xc')](_0x10d5('0xb'));
        $(_0x10d5('0xd'))[_0x10d5('0xe')]('$' + $(this)['attr']('data-variant-price'));
        $(_0x10d5('0xf'))[_0x10d5('0x10')]($(this)[_0x10d5('0x5')](_0x10d5('0x11')));
    });
    $(_0x10d5('0x12'))['change'](function (_0x499a28) {
        $[_0x10d5('0x3')]({
            'url': window[_0x10d5('0x7')]['href'],
            'method': _0x10d5('0x13'),
            'data': {'upid': $(this)[_0x10d5('0x5')](_0x10d5('0x6')), 'quantity': $(this)[_0x10d5('0x10')]()},
            'success': function (_0x5333e0) {
                window['location'][_0x10d5('0x14')]();
            }
        });
    });
    $(_0x10d5('0x0'))[_0x10d5('0x1')](function (_0x4c098f) {
        _0x4c098f[_0x10d5('0x2')]();
        $[_0x10d5('0x3')]({
            'url': window[_0x10d5('0x7')][_0x10d5('0x15')],
            'method': _0x10d5('0x4'),
            'data': {'upid': $(this)['attr'](_0x10d5('0x6'))},
            'success': function (_0x7db138) {
                window[_0x10d5('0x7')][_0x10d5('0x14')]();
            }
        });
    });

}); // end jquery function
